import { Box, Text } from 'grommet';
import { ReactNode } from 'react';
import { AddNewButton } from './AddNewButton';

export type EmptyStateProps = {
  /** "No roles yet" */
  title: string;
  /** One line on why it matters or what to do next */
  body: string;
  /** "Add role": an add button below the text */
  actionLabel?: string;
  onAction?: () => void;
  /** Filled, for the step to take first; outlined otherwise */
  primary?: boolean;
  /** An action other than adding (a link, say), in place of the add button */
  children?: ReactNode;
};

/** What an empty panel shows: what's missing, why it matters, and the button that adds it */
export const EmptyState = ({ title, body, actionLabel, onAction, primary = false, children }: EmptyStateProps) => (
  <Box align="center" pad="24px" gap="8px" fill="horizontal">
    <Text size="16px" weight={600} color="text-heading" textAlign="center">
      {title}
    </Text>
    <Box width={{ max: '320px' }}>
      <Text size="small" color="text-label" textAlign="center">
        {body}
      </Text>
    </Box>
    {(children || (actionLabel && onAction)) && (
      <Box margin={{ top: '4px' }}>
        {children ??
          (actionLabel && onAction && <AddNewButton label={actionLabel} onClick={onAction} secondary={!primary} />)}
      </Box>
    )}
  </Box>
);
